import React from 'react';

import CardHOC from './Components/CardHOC';
import Attachment from '../../Types/Components/Attachment';

export default function (props) {
  return <CardHOC question={props.question}>
    <Attachment {...props} />
  </CardHOC>
}
